import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { useParams } from 'react-router-dom';
import './WebPage.scss'; // Import the SCSS file
import OrdersDashboard from '../ViewOrders/ViewOrders';
import BusinessContext from '../../components/BusinessContext/BusinessContext';
import { useUser } from '../../context/UserContext';
import OpeningHours from '../OpeningHours/OpeningHours';
import Menu from "../Menu/Menu";
import AboutUs from '../BusinessAboutUs/BusinessAboutUs';
import BusinessComplaints from '../BusinessComplaints/BusinessComplaints';
import BusinessCallbacks from '../BusinessComplaints/BusinessCallbacks';

import FormSettings from "../Form/FormSettings/FormSettings";
import { toast } from 'react-toastify';
import CalendarTabs from './CalendarTabs';
function WebBusinessPage() {
    const { slug } = useParams();
    const { user, setUser } = useUser();
    const [businessData, setBusinessData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [colorData, setColorData] = useState(null);
    const [backgGroundColorGradient, setBackgGroundColorGradient] = useState('');
    const widgetLoaded = useRef(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const navigate = useNavigate();


    // Add scroll function near other functions (after handleLogout function)
    const scrollToOrders = () => {
        const ordersSection = document.getElementById('orders-section');
        if (ordersSection) {
            ordersSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    const scrollToBookings = () => {
        const ordersSection = document.getElementById('booking-section');
        if (ordersSection) {
            ordersSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    const scrollToComplaints = () => {
        const ordersSection = document.getElementById('booking-complaints');
        if (ordersSection) {
            ordersSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    const scrollToCallbacks = () => {
        const ordersSection = document.getElementById('booking-callbacks');
        if (ordersSection) {
            ordersSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    // alert("user", user);
    const industryThemes = [
        {
            industry: "food",
            name: "Food & Beverage",
            primary: "#ae4645ff", // Red
            secondary: "#FF9800", // Orange
            tertiary: "#eca740ff", // Green
            image: `${process.env.REACT_APP_REACT_DOMAIN}/ideogram-v3.0_Indian_resturant_with_many_color_full_dishes_on_the_menu-0.jpg`,
            icon: "🍔"
        },
        {
            industry: "health",
            name: "Healthcare",
            primary: "#2196F3", // Blue
            secondary: "#4CAF50", // Green
            tertiary: "#FF4081", // Pink
            image: `${process.env.REACT_APP_REACT_DOMAIN}/ideogram-v3.0_Indian_resturant_with_many_color_full_dishes_on_the_menu-0.jpg`,
            icon: "🏥"
        },
        {
            industry: "technology",
            name: "Technology",
            primary: "#3F51B5", // Indigo
            secondary: "#00BCD4", // Cyan
            tertiary: "#FF9800", // Orange
            image: `${process.env.REACT_APP_REACT_DOMAIN}/ideogram-v3.0_Indian_resturant_with_many_color_full_dishes_on_the_menu-0.jpg`,
            icon: "💻"
        },
        {
            industry: "finance",
            name: "Finance & Banking",
            primary: "#4CAF50", // Green
            secondary: "#FFC107", // Amber
            tertiary: "#795548", // Brown
            image: `${process.env.REACT_APP_REACT_DOMAIN}/ideogram-v3.0_Indian_resturant_with_many_color_full_dishes_on_the_menu-0.jpg`,
            icon: "💰"
        },
        {
            industry: "education",
            name: "Education",
            primary: "#9C27B0", // Purple
            secondary: "#FF9800", // Orange
            tertiary: "#2196F3", // Blue
            image: `${process.env.REACT_APP_REACT_DOMAIN}/ideogram-v3.0_Indian_resturant_with_many_color_full_dishes_on_the_menu-0.jpg`,
            icon: "🎓"
        },
        {
            industry: "retail",
            name: "Retail & E-commerce",
            primary: "#FF5722", // Deep Orange
            secondary: "#FFC107", // Amber
            tertiary: "#795548", // Brown
            image: `${process.env.REACT_APP_REACT_DOMAIN}/ideogram-v3.0_Indian_resturant_with_many_color_full_dishes_on_the_menu-0.jpg`,
            icon: "🛒"
        },
        {
            industry: "travel",
            name: "Travel & Hospitality",
            primary: "#00BCD4", // Cyan
            secondary: "#4CAF50", // Green
            tertiary: "#FF9800", // Orange
            image: `${process.env.REACT_APP_REACT_DOMAIN}/ideogram-v3.0_Indian_resturant_with_many_color_full_dishes_on_the_menu-0.jpg`,
            icon: "✈️"
        },
        {
            industry: "estate agent",
            name: "Real Estate",
            primary: "#795548", // Brown
            secondary: "#FF9800", // Orange
            tertiary: "#4CAF50", // Green
            image: `${process.env.REACT_APP_REACT_DOMAIN}/ideogram-v3.0_Indian_resturant_with_many_color_full_dishes_on_the_menu-0.jpg`,
            icon: "🏠",
            footer_color: 'white',
        },
        {
            industry: "manufacturing",
            name: "Manufacturing",
            primary: "#607D8B", // Blue Grey
            secondary: "#FF5722", // Deep Orange
            tertiary: "#2196F3", // Blue
            image: `${process.env.REACT_APP_REACT_DOMAIN}/ideogram-v3.0_Indian_resturant_with_many_color_full_dishes_on_the_menu-0.jpg`,
            icon: "🏭"
        },
        {
            industry: "garage",
            name: "Garage",
            primary: "#607D8B", // Blue Grey
            secondary: "#FF5722", // Deep Orange
            tertiary: "#2196F3", // Blue
            image: `${process.env.REACT_APP_REACT_DOMAIN}/garage.jpg`,
            icon: "🎬",
            footer_color: 'white',

        },
        {
            industry: "dental",
            name: "Dental",
            primary: "#2AA89A", // Teal
            secondary: "#1A6DBF", // Blue
            tertiary: "#E8F2FC", // Light Blue
            image: `${process.env.REACT_APP_REACT_DOMAIN}/dental.jpg`,
            icon: "🦷"
        },
        {
            industry: "restaurant",
            name: "Restaurant",
            primary: "#E53935", // Red
            secondary: "#FF9800", // Orange
            tertiary: "#eca740ff", // Green
            image: `${process.env.REACT_APP_REACT_DOMAIN}/indian.jpg`,
            icon: "🍽️"
        }
    ];
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const handleSaveSuccess = (updatedProfile) => {
        toast.success("Settings Saved");
        // You might want to refresh other data or show a success message
    };

    const showWidget = (e) => {
        e.preventDefault(); // stops tel: calling
        e.stopPropagation();

        // Ensure widget is loaded
        if (!widgetLoaded.current && businessData?.id) {
            loadWidget(businessData.id);
        }

        // Click the widget toggle
        setTimeout(() => {
            const toggleBtn = document.querySelector(".gemini-chat-toggle");
            if (toggleBtn) toggleBtn.click();
        }, 300);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userData');
        localStorage.removeItem('currentBusinessId');
        setIsLoggedIn(false);
        setUser(null);
        setShowLogoutModal(false);
        window.location.href = '/';
    };

    // Function to find color data based on business type
    const findColorData = (businessType) => {
        if (!businessType) return null;

        // Convert business type to lowercase for case-insensitive matching
        const type = businessType.toLowerCase().trim();

        // Try exact match first
        let theme = industryThemes.find(theme =>
            theme.industry.toLowerCase() === type
        );

        // If no exact match, try partial match
        if (!theme) {
            theme = industryThemes.find(theme =>
                type.includes(theme.industry.toLowerCase()) ||
                theme.industry.toLowerCase().includes(type)
            );
        }

        // Fallback to healthcare if no match found
        return theme || industryThemes.find(theme => theme.industry === "health");
    };

    // Update color data when business data changes
    useEffect(() => {
        if (businessData && businessData.business_type) {
            const foundColorData = findColorData(businessData.business_type);
            setColorData(foundColorData);

            if (foundColorData) {
                // Create gradient string
                const gradient = `linear-gradient(135deg, ${foundColorData.primary} 0%, ${foundColorData.secondary} 100%)`;
                setBackgGroundColorGradient(gradient);

                // Also set CSS custom properties for use in SCSS
                document.documentElement.style.setProperty('--primary-color', foundColorData.primary);
                document.documentElement.style.setProperty('--secondary-color', foundColorData.secondary);
                document.documentElement.style.setProperty('--tertiary-color', foundColorData.tertiary);
            }
        }
    }, [businessData]);

    // Function to load the widget
    const loadWidget = (clientId) => {
        if (widgetLoaded.current || !clientId) return;
        const script = document.createElement('script');
        script.src = `${process.env.REACT_APP_WIDGET_URL}/widget.js?clientId=${clientId}&apiUrl=${process.env.REACT_APP_API_URL}`;
        script.async = true;
        script.setAttribute('data-client-id', clientId);

        document.body.appendChild(script);
        widgetLoaded.current = true;

        // Cleanup function
        return () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
            const widgetElements = document.querySelectorAll(
                '.gemini-chat-toggle, .gemini-widget-container, .gemini-transcript-box'
            );
            widgetElements.forEach(el => el.remove());
            widgetLoaded.current = false;
        };
    };

    // Function to fetch business data
    const fetchBusinessData = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${process.env.REACT_APP_API_URL}/business/${slug}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });

            const result = await response.json();
            // console.log("API Result:", result);

            // 1. Check if the API explicitly said it failed OR the nested data is missing
            if (!result.data.business_type) {
                setError('Business not found or failed to load');

                setTimeout(() => {
                    navigate('/');
                }, 2000);
                return; // Stop execution here
            }

            // 2. Success path: Set the nested business data
            setBusinessData(result.data);
            setError(null);

            // 3. Fix the widget loader reference
            // Use result.data.id (since that's the shape of your joined object)
            if (result.data.id) {
                loadWidget(result.data.id);
            }

        } catch (err) {
            console.error('Error fetching business data:', err);
            setError('An unexpected error occurred');
        } finally {
            setLoading(false);
        }
    };


    const getImageUrl = (imageFileName) => {
        return `${imageFileName}`;
    };

    useEffect(() => {
        if (slug) {
            fetchBusinessData();
        }

        return () => {
            if (widgetLoaded.current) {
                const widgetElements = document.querySelectorAll(
                    '.gemini-chat-toggle, .gemini-widget-container, .gemini-transcript-box'
                );
                widgetElements.forEach(el => el.remove());
                widgetLoaded.current = false;
            }
        };
    }, [slug]);

    if (loading) {
        return (
            <div className="dental-surgery-page">
                <div className="loading-state">
                    <div className="spinner-container">
                        <div className="spinner"></div>
                        <p>Loading data practice information...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="dental-surgery-page">
                <div className="error-state">
                    <h4>Error Loading Page Practice</h4>
                    <p>{error}</p>
                    <p className="mb-3">Please check if the practice exists or try again later.</p>
                    <button className="retry-btn" onClick={fetchBusinessData}>
                        Retry Loading
                    </button>
                </div>
            </div>
        );
    }

    // Get tagline based on business type
    const getTagline = () => {
        if (!colorData) return businessData.business_type;

        const taglines = {
            dental: "Dental Care",
            restaurant: "Fine Dining",
            food: "Food & Beverage",
            health: "Healthcare",
            technology: "Tech Solutions",
            finance: "Financial Services",
            education: "Education",
            retail: "Shopping",
            travel: "Travel Services",
            "real-estate": "Real Estate",
            manufacturing: "Manufacturing",
            entertainment: "Entertainment"
        };

        return taglines[colorData.industry] || colorData.name;
    };
    const handleLogoutClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowLogoutModal(true);
    };

    return (
        <div className="dental-surgery-page">
            {/* Header/Hero Section */}
            <header className="dental-header" style={{ position: 'relative' }}>
                {/* Overlay Navbar */}

                {(user && user?.business_id === businessData.id) &&
                    <div className='navbar-overlay-hero-image' style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        zIndex: 100,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '15px 30px',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        backdropFilter: 'blur(10px)',
                        borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
                    }}>
                        <div>
                            {businessData.business_type !== "Estate Agent" &&
                                <button className="btn-glass-primary"
                                    onClick={scrollToOrders}
                                ><i className="fas fs-5 fa-shopping-cart me-2"></i>Orders
                                </button>
                            }
                            <button
                                onClick={scrollToBookings}
                                className="btn-glass-primary ms-2"><i className="fas fs-5 fa-calendar-alt me-2"></i>Bookings
                            </button>
                            <button
                                onClick={scrollToComplaints}
                                className="btn-glass-danger ms-2"> <i className="fas fs-5 fa-exclamation-triangle me-2"></i>Complaints
                            </button>
                            <button
                                onClick={scrollToCallbacks}
                                className="btn-glass-info ms-2"> <i className="fas fs-5 fa-phone-alt me-2"></i>Callbacks
                            </button>
                            <button
                                onClick={() => setIsSettingsOpen(true)}
                                className="btn-glass-primary ms-2"
                            >
                                <i className="fas fs-5 fa-cog me-2"></i>Settings
                            </button>
                        </div>
                        <div>

                        </div>

                        <button
                            className="btn-glass-danger"
                            onClick={handleLogoutClick}

                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                                e.target.style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                                e.target.style.transform = 'translateY(0)';
                            }}
                        >
                            <i className="fas fs-5 fa-sign-out-alt me-2"></i>{user?.name} | Logout
                        </button>
                    </div>
                }

                {/* Background Image Container */}
                <div
                    className="header-background"
                    style={{
                        backgroundImage: colorData?.image ? `url(${getImageUrl(`${process.env.REACT_APP_REACT_DOMAIN}/${businessData.hero_image_path}`)})` : 'none', backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 0
                    }}
                >
                    {/* Color Overlay */}
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            background: colorData ?
                                `linear-gradient(135deg, 
                        ${colorData.primary}CC 0%, 
                        ${colorData.secondary}99 50%,
                        ${colorData.primary}DD 100%
                    )` :
                                backgGroundColorGradient,
                            opacity: 0.85,
                            mixBlendMode: 'multiply'
                        }}
                    />
                </div>

                {/* Content Container */}
                <div className="header-container fade-in" style={{
                    position: 'relative',
                    zIndex: 1,
                    paddingTop: '80px' // Added padding to prevent content overlap with navbar
                }}>
                    <div className="header-content">
                        <div
                            className="business-tagline label-glass-primary poppin"
                            style={{
                                backgroundColor: colorData?.tertiary || 'rgba(232, 242, 252, 0.9)',
                                color: colorData?.primary || '#1a6dbf',
                                backdropFilter: 'blur(10px)',
                                border: `1px solid ${colorData?.tertiary || 'rgba(232, 242, 252, 0.3)'}`
                            }}
                        >
                            {getTagline()}
                        </div>

                        <h1 className='mt-3 text-white poppin' style={{
                            textShadow: '0 2px 10px rgba(0,0,0,0.3)',
                            fontSize: '3.5rem',
                            fontWeight: '700'
                        }}>
                            {businessData.business_name}
                        </h1>

                        <p className="header-description text-white" style={{
                            fontSize: '1.2rem',
                            maxWidth: '800px',
                            margin: '0 auto',
                            textShadow: '0 1px 5px rgba(0,0,0,0.3)',
                            backgroundColor: 'rgba(0,0,0,0.2)',
                            padding: '15px 25px',
                            borderRadius: '12px',
                            backdropFilter: 'blur(5px)'
                        }}>
                            {businessData.hero_text}
                        </p>

                        <div className="contact-buttons mt-4">
                            <a
                                href={`tel:${businessData.twillio_number || ''}`}
                                className="btn-glass-warning"
                                style={{
                                    borderRadius: "25px",
                                    padding: "12px 30px",
                                    backgroundColor: colorData?.secondary || '#FF9800',
                                    color: 'white',
                                    textDecoration: 'none',
                                    fontWeight: '600',
                                    fontSize: '1.1rem',
                                    boxShadow: '0 5px 15px rgba(0,0,0,0.2)',
                                    border: 'none',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => e.target.style.transform = 'translateY(-3px)'}
                                onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                            >
                                📞 <span className='ms-2'>Call <span style={{ letterSpacing: "2px" }}>{`${businessData.twillio_number || ''}`}</span></span>
                            </a>
                            <a
                                
                                className="btn-glass-info ms-3"
                                onClick={showWidget}


                                style={{
                                    borderRadius: "25px",
                                    padding: "12px 30px",
                                    backgroundColor: colorData?.primary || '#1a6dbf',
                                    color: 'white',
                                    textDecoration: 'none',
                                    fontWeight: '600',
                                    fontSize: '1.1rem',
                                    boxShadow: '0 5px 15px rgba(0,0,0,0.2)',
                                    border: 'none',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => e.target.style.transform = 'translateY(-3px)'}
                                onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                            >
                                ✉️ <span className='ms-2'>Make Booking</span>
                            </a>
                        </div>

                        {/* Optional: Industry icon badge */}
                        {colorData?.icon && (
                            <div className="mt-4" style={{
                                fontSize: '4rem',
                                opacity: 0.8,
                                textShadow: '0 0 20px rgba(255,255,255,0.5)'
                            }}>
                                {colorData.icon}
                            </div>
                        )}
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <div className='container'>
                <div className="row ">
                    {(businessData.business_type === 'Restaurant' && businessData.id === user?.business_id) &&
                        // Anchor point here
                        <div className="col-12" id="orders-section">
                            <OrdersDashboard clientId={user?.id} colorData={colorData} backgGroundColorGradient={backgGroundColorGradient} />
                        </div>
                    }

                    {(businessData.business_type !== '' && businessData.id === user?.business_id) &&
                        <div className="col-12" id="booking-section">
                            <CalendarTabs
                                calendars={businessData.calendars || []}
                                userId={user?.id}
                                userBusinessId={user?.business_id}
                                businessData={businessData}
                                onCalendarChange={(calendarId) => {
                                    // console.log('Active calendar changed to:', calendarId);
                                    // You can update URL or state here
                                }}
                                defaultActiveId={1} // Optional: set default active calendar
                                showStats={true}
                                showSettings={true}
                            />
                        </div>
                    }
                    {(businessData.business_type !== '' && businessData.id === user?.business_id) &&
                        <div className="col-12" id="booking-complaints">
                            <BusinessComplaints clientId={user?.id} colorData={colorData} />
                        </div>
                    }
                    {(businessData.business_type !== '' && businessData.id === user?.business_id) &&
                        <div className="col-12" id="booking-callbacks">
                            <BusinessCallbacks clientId={user?.id} colorData={colorData} />
                        </div>
                    }



                    <div className='col-12'>
                        <AboutUs aboutUs={businessData.description} colorData={colorData} />
                    </div>
                    <div>
                        <Menu categories={businessData.categories} colorData={colorData} business_type={businessData.business_type} />
                    </div>
                    {businessData?.context && businessData.context.length > 0 &&
                        < div className='col-12'>
                            <BusinessContext contextItems={businessData.context} colorData={colorData} />
                        </div>
                    }
                    {businessData?.hours && businessData.hours.length > 0 &&
                        <div className='col-12'>
                            <OpeningHours openingHours={businessData.hours} colorData={colorData} />
                        </div>
                    }


                </div>
            </div>

            {/* Footer */}
            <footer
                className="dental-footer fade-in"
                style={{
                    backgroundColor: colorData?.tertiary || '#E8F2FC',
                    color: colorData?.footer_color || 'black'
                }}
            >
                <div className="footer-content  mt-3 text-black">
                    <div className="footer-section">
                        <h4 className='poppin'
                            style={{
                                color: colorData?.footer_color || 'black',
                                borderBottom: `4px solid rgba(225, 225, 255, 0.4)`,
                                paddingBottom: "20px"
                            }}
                        >{businessData.business_name}</h4>
                        <p className='poppin'
                            style={{
                                color: colorData?.footer_color || 'black'
                            }}
                        >
                            {businessData.hero_text}
                        </p>
                        <div className="social-links">
                            <a href="#" aria-label="Facebook">f</a>
                            <a href="#" aria-label="Instagram">📸</a>
                            <a href="#" aria-label="Twitter">𝕏</a>
                        </div>
                    </div>

                    <div className="footer-section">
                        <h4 className='poppin'
                            style={{
                                color: colorData?.footer_color || 'black',
                                borderBottom: `4px solid rgba(225, 225, 255, 0.4)`,
                                paddingBottom: "20px"
                            }}
                        >Contact Info</h4>
                        {businessData.address && <p className='poppin' style={{
                            color: colorData?.footer_color || 'black'
                        }}>📍 {businessData.address}</p>}
                        {businessData.phone && <p className='poppin' style={{
                            color: colorData?.footer_color || 'black'
                        }}>📞 {businessData.phone}</p>}
                        {businessData.email && <p className='poppin' style={{
                            color: colorData?.footer_color || 'black'
                        }}>✉️ {businessData.email}</p>}
                    </div>

                    <div className="footer-section">
                        <h4 className='poppin' style={{
                            color: colorData?.footer_color || 'black',
                            borderBottom: `4px solid rgba(225, 225, 255, 0.4)`,
                            paddingBottom: "20px"
                        }}>Quick Links</h4>
                        <p className='poppin' ><a style={{
                            color: colorData?.footer_color || 'black'
                        }} href="#">Home</a></p>
                        <p className='poppin' ><a style={{
                            color: colorData?.footer_color || 'black'
                        }} href="#">Services</a></p>
                        <p className='poppin' ><a style={{
                            color: colorData?.footer_color || 'black'
                        }} href="#">Book Appointment</a></p>
                        <p className='poppin' ><a href="#" style={{
                            color: colorData?.footer_color || 'black'
                        }}>Emergency Care</a></p>
                    </div>
                </div>

                <div className="copyright poppin" style={{
                    color: colorData?.footer_color || 'black'
                }}>
                    <p style={{
                        color: colorData?.footer_color || 'black'
                    }}>
                        © {new Date().getFullYear()} {businessData.business_name}.
                        All rights reserved. | <strong>{businessData.business_name}</strong>
                    </p>
                    <p className="mt-1" style={{
                        color: colorData?.footer_color || 'black'
                    }}>
                        <small>
                            <i className="bi bi-chat-left-text" style={{
                                color: colorData?.footer_color || 'black'
                            }}></i>
                            Voice Assistant is active - Click the chat icon in bottom right to speak with our AI assistant
                        </small>
                    </p>
                </div>
            </footer>
            {/* Logout Confirmation Modal */}
            {
                showLogoutModal && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Logout</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowLogoutModal(false)}
                                >
                                    ×
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to logout from the system?</p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowLogoutModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={handleLogout}
                                >
                                    Logout
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }
            {/* Settings Popup */}
            <FormSettings
                isOpen={isSettingsOpen}
                onClose={() => setIsSettingsOpen(false)}
                businessProfile={businessData}
                onSaveSuccess={handleSaveSuccess}
            />
        </div >
    );
}

export default WebBusinessPage;